import axios from '@/axios'

export default {
	namespaced: true,

	state: {},

	actions: {
		fetchPurchaseSimulation({ commit }, { purchaseId }) {
			return axios.get(`/simulation/purchase/${purchaseId}`).then(data => {
				return data;
			})
		},
		fetchLatestSimulation({ commit }) {
			return axios.get('/simulation/getLastPurchaseSimulation').then(data => {
				return data;
			})
		},
		fetchTestingSimulation({ commit }) {
			return axios.get('/simulation/getLastSimulation').then(data => {
				return data;
			})
		},

		create({ commit }, { purchaseId, date, providerId, entryNo, weight, ownerId, exchangeRate, expenses, spaceBill, pxCal, simulationItems }) {
			return axios.post('/simulation', { purchaseId, date, providerId, entryNo, weight, ownerId, exchangeRate, expenses, spaceBill, pxCal, simulationItems });
		},

		updatePurchaseState({ commit }, { id, administrationPrice, administrationAcceptance, farmerAcceptance }) {
			return axios.put(`/simulation/${id}/status`, { administrationPrice, administrationAcceptance, farmerAcceptance })
		},

		update({ commit }, { id, purchaseId, date, providerId, entryNo, weight, ownerId, exchangeRate, expenses, spaceBill, pxCal, simulationItems }) {
			return axios.put(`/simulation/${id}`, { purchaseId, date, providerId, entryNo, weight, ownerId, exchangeRate, expenses, spaceBill, pxCal, simulationItems });
		}
	},

	mutations: {},

	getters: {}
}